import React, { memo, useState } from "react";
import { Box, Modal, Button } from "@mui/material";
import "./custommodal.scss";
import { isValue } from "../../../utils/constants/constants";
import moment from "moment";

const CustomModal = ({
  open,
  type,
  error,
  content,
  modaltype,
  okDisabled,
  cancellable,
  handleClose,
  handleClickOk,
  handleCreateGroup,
  setGroupnameError,
  handleGlobalDownload,
  maxDate,
  minDate,
  currentDate,
  groupName,
  setGroupName,
  // confirmLabel/cancelLabel were added to support the Deep Search confirmation modal, disabled for now
  // confirmLabel,
  // cancelLabel
}) => {

  const [downloadDate, setDownloadDate] = useState(currentDate);
  const [dateErr, setDateErr] = useState(isValue?.emptyString);
  const [dateErrCondition, setDateErrCondition] = useState(false);

  const handleOnChangeDate = (e) => {
    const minCheck = moment(e.target.value).format("YYYY-MM-DD") >= moment(minDate).format("YYYY-MM-DD");
    const maxCheck = moment(e.target.value).format("YYYY-MM-DD") <= moment(maxDate).format("YYYY-MM-DD");
    if (minCheck && maxCheck) {
      setDownloadDate(e.target.value);
      setDateErr(isValue?.emptyString);
      setDateErrCondition(false);
    } else {
      setDownloadDate(currentDate);
      setDateErr(isValue?.emptyString);
      setDateErrCondition(true);
    }
  }

  const handleSetGroup = (e) => {
    const value = e?.target?.value
    const trimmedValue = value.trim();
    if (trimmedValue !== "") {
      setGroupName(e?.target?.value);
      setGroupnameError(isValue?.emptyString)
    } else {
      setGroupName("");
      setGroupnameError(isValue?.emptyString)
    }
  }

  return (
    <Modal backdrop={"static"} open={!!open} className={modaltype === "groupwarning" ? "common-modal no-translate d-flex align-center center-modal" : modaltype === "globalDownload" ? "common-modal no-translate d-flex align-center dwn-center-modal" : "common-modal no-translate"}>
      <Box className="modal-box" id={minDate === null ? "minht" : ""}>
        {!content && type === "addGroup" ?
          <div className=" mb-15">
            <h2>Group Name</h2>
            <input type="text" placeholder="Group Name" className="input-common" value={groupName} onChange={(e) => handleSetGroup(e)} />
            {!!error && <small className="err-txt">{error}</small>}
          </div> :
          !content && type === "globalDownload" ?
            <div className="dwn-date">
              {minDate !== null && <div className="cross-btn"><button onClick={handleClose}>+</button></div>}
              <h3>Global Download Request</h3>
              {minDate !== null ? <>
                <p>Select the date of data extraction:</p>
                <input type="date" min={minDate} max={maxDate} value={downloadDate} className="input-common" onChange={(e) => { handleOnChangeDate(e) }} />
                {!!dateErr && <small className="err-txt">{dateErr}</small>}
              </> : <p>Global Download will be available from <b>{moment(currentDate).add(1, "day").format("YYYY-MM-DD")}</b></p>}
            </div> :
            <>
              <h2>{content?.[0]?.modalHeading ?? content?.[0]?.header}</h2>
              <p>{content?.[1]?.modalContent}</p>
              {content?.[2]?.modalContentTwo?.length && <p>{content?.[2]?.modalContentTwo}</p>}
            </>}
        <div className="textleft">
          {cancellable && <Button type="button" className="cancel-button" onClick={() => { handleClose(); setGroupName?.("") }}> Cancel</Button>}
          {modaltype === "globalDownload" ?
            <>
              {minDate !== null ? <Button type={type ?? "button"} className="secondary_button dwn-btn" disabled={okDisabled}
                onClick={(e) => downloadDate ? (handleGlobalDownload(downloadDate), setDownloadDate(currentDate)) : setDateErr(dateErrCondition ? "Please select a valid date" : "Please select any date.")}>Download</Button> : ""}
              <p>You will receive an email containing an S3 link to download the file</p>
              {minDate === null && <Button type={type ?? "button"} className="secondary_button" disabled={okDisabled} onClick={handleClose}>
                Ok
              </Button>}
            </>
            :
            <Button type={type ?? "button"} className="secondary_button" disabled={okDisabled}
              onClick={(e) => { type !== "addGroup" ? handleClickOk(e) : handleCreateGroup(groupName);  }}>{modaltype === "groupwarning" ? "Edit Shop" : "OK"}</Button>
          }
        </div>
      </Box>
    </Modal>
  );
};

export default memo(CustomModal);
